<button 
  [ngClass]="{
    'pill-tab-button': true,
    'pill-tab-button--selected': isSelected,
    'pill-tab-button--noglow': !hasShadow,
    'pill-tab-button--selected--outline': isSelected,
    'pill-tab-button--outline-hover': true,
    'typography-text-medium-regular-primary': isSelected,
    'typography-text-medium-regular-tertiary': !isSelected
  }"
  (click)="onClick()"
  [style.text-transform]="themeService.buttonConfig().textTransform"
>
  {{ label }}
</button>
